import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  obterDadosGeraisFamiliaAptaExcusaoPeloCPFIntegranteFamiliar,
  excluirCadastroFamilia,
} from '../../api/familiaAPI';
import {
  excluirPreCadastroFamilia,
  obterDadosGeraisPreFamiliaAptaExcusaoPeloCPFIntegranteFamiliar,
} from '../../api/preCadastroAPI';
import { RootState } from '../../app/store';

export interface ExclusaoCadastralState {
  isExclusaoIniciada: any;
  familia: any;
  codigoErro: string;
  mensagemErro: string;
  responseError: any;
}

const initialState: ExclusaoCadastralState = {
  isExclusaoIniciada: false,
  familia: null,
  codigoErro: '',
  mensagemErro: '',
  responseError: null,
};

export const obterFamilia = createAsyncThunk(
  'exclusaoCadastral/obterFamilia',
  async (data: any) => {
    return obterDadosGeraisFamiliaAptaExcusaoPeloCPFIntegranteFamiliar(
      data.cpf,
      data.numeroFamiliar
    );
  }
);

export const obterPreFamilia = createAsyncThunk(
  'exclusaoCadastral/obterPreFamilia',
  async (data: any) => {
    return obterDadosGeraisPreFamiliaAptaExcusaoPeloCPFIntegranteFamiliar(
      data.cpf,
      data.idPreFamilia
    );
  }
);

export const excluirFamilia = createAsyncThunk(
  'exclusaoCadastral/excluirFamilia',
  async (data: any) => {
    return excluirCadastroFamilia(data.cpf, data.numeroFamiliar);
  }
);

export const excluirPreFamilia = createAsyncThunk(
  'exclusaoCadastral/excluirPreFamilia',
  async (data: any) => {
    return excluirPreCadastroFamilia(data.cpf, data.idPreFamilia);
  }
);

export const exclusaoCadastralSlice = createSlice({
  name: 'exclusaoCadastral',
  initialState,
  reducers: {
    setIniciarExclusao: (state, action) => {
      state.isExclusaoIniciada = action.payload;
    },

    limpar: (state) => {
      state.familia = null;
      state.codigoErro = '';
      state.mensagemErro = '';
      state.isExclusaoIniciada = false;
    },

    limparResponseError: (state) => {
      state.responseError = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(obterFamilia.fulfilled, (state, action) => {
      if (action.payload.codigoErro !== '0') {
        state.codigoErro = action.payload.codigoErro;
        state.mensagemErro = action.payload.mensagemErro;
      }

      state.familia = action.payload.familia;
    });
    builder.addCase(obterPreFamilia.fulfilled, (state, action) => {
      if (action.payload.codigoErro !== '0') {
        state.codigoErro = action.payload.codigoErro;
        state.mensagemErro = action.payload.mensagemErro;
      }

      state.familia = action.payload.familia;
    });
    builder.addCase(excluirFamilia.fulfilled, (state, action) => {
      state.codigoErro = action.payload.codigoErro;
      state.mensagemErro = action.payload.mensagemErro;
    });
    builder.addCase(excluirFamilia.rejected, (state, action) => {
      state.responseError = action.error;
    });
    builder.addCase(excluirPreFamilia.fulfilled, (state, action) => {
      state.codigoErro = action.payload.codigoErro;
      state.mensagemErro = action.payload.mensagemErro;
    });
    builder.addCase(excluirPreFamilia.rejected, (state, action) => {
      state.responseError = action.error;
    });
  },
});

export const { setIniciarExclusao, limpar, limparResponseError } = exclusaoCadastralSlice.actions;

export const selectFamilia = (state: RootState) => state.exclusaoCadastral.familia;
export const selectExclusaoIniciada = (state: RootState) => state.exclusaoCadastral.isExclusaoIniciada;
export const selectCodigoErro = (state: RootState) => state.exclusaoCadastral.codigoErro;
export const selectMensagemErro = (state: RootState) => state.exclusaoCadastral.mensagemErro;
export const selectResponseError = (state: RootState) => state.exclusaoCadastral.responseError;

export default exclusaoCadastralSlice.reducer;
